/**********************************************************************************************************************
 *
 *
 * This store is obsolete, use debitCardManagement.ts instead
 *
 *
**********************************************************************************************************************/

import {
    FetchState,
    FiservDebitCardInfo,
    FiservDebitCardsState,
    SetCardPinRequest,
    FiservDebitCardsDetailLocation,
    FiservDebitCardStatus,
  DependentRequest,
} from "@/shared/types";

import * as CardService from "@/shared/api/cardService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

export const initialState: FiservDebitCardsState = {
    fiservDebitCardsFetchState: FetchState.Uninitialized,
    fiservDebitCards: [],
    isCardStatusChanging: false,
    detailLocation: FiservDebitCardsDetailLocation.ActionMenu,
    fiservDebitCardDependentModalOpen: false
};

export const useFiservDebitCardsStore = defineStore("fiservDebitCards", {
    state: () => (_.cloneDeep(initialState)),
    getters: {
        fiservDebitCardsLoading: state => state.fiservDebitCardsFetchState === FetchState.Loading,
        isPrimaryCardActive: state => state.fiservDebitCards.length > 0 &&
                             state.fiservDebitCards[0].cardStatus !== FiservDebitCardStatus.Cancelled,
    },
    actions: {
        resetState () {
            this.fiservDebitCards = [];
            this.fiservDebitCardsFetchState = FetchState.Uninitialized;
        },

        setFetchState (fetchState: FetchState) {
            this.fiservDebitCardsFetchState = fetchState;
        },

        setfiservDebitCardDetailLocation (location: FiservDebitCardsDetailLocation) {
            this.detailLocation = location;
        },

  setDependentModalOpen (isOpen: boolean) {
    this.fiservDebitCardDependentModalOpen = isOpen;
  },

        setFiservDebitCardInfos (fiservDebitCards: FiservDebitCardInfo[]) {
            this.fiservDebitCards = fiservDebitCards;
            this.fiservDebitCardsFetchState = FetchState.Loaded;
        },

        setFiservDebitCardIsPinSetTrue (fiservUserInfoId: number) {
            const debitCard = this.fiservDebitCards.find(i =>
                i.fiservUserInfoId === fiservUserInfoId);

            debitCard.isPinSet = true;
        },

        setFiservDebitCardStatusCancelled (fiservUserInfoId: number) {
            const debitCard = this.fiservDebitCards.find(i =>
                i.fiservUserInfoId === fiservUserInfoId);

            debitCard.cardStatus = FiservDebitCardStatus.Cancelled;
            debitCard.isPinSet = false;
        },

        setFiservDebitCardStatusReplaced (fiservUserInfoId: number) {
            const debitCard = this.fiservDebitCards.find(i =>
                i.fiservUserInfoId === fiservUserInfoId);

            debitCard.cardStatus = FiservDebitCardStatus.ReplacementRequested;
        },
        setFiservDebitCardStatusActive (fiservUserInfoId: number) {
            const debitCard = this.fiservDebitCards.find(i =>
                i.fiservUserInfoId === fiservUserInfoId);

            debitCard.cardStatus = FiservDebitCardStatus.Active;
        },

        setDebitCardStatusChanging () {
            this.isCardStatusChanging = true;
        },

        setDebitCardStatusNotChanging () {
            this.isCardStatusChanging = false;
        },
        getFiservDebitCards (): Promise<any> {
            const featureFlagStore = useFeatureFlagStore();

            if (featureFlagStore.flags.bend15878DebitCardManagementUi === false) {
                return Promise.resolve();
            }

            this.setFetchState(FetchState.Loading);
            return CardService.getFiservDebitCards()
                .then(response => {
                    this.setFiservDebitCardInfos(response.data.cards);
                }).catch(err => {
                    this.resetState();
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        },
        setFiservDebitCardPIN (args?: { oldPin?: string, pin: string, fiservUserInfoId: number }): Promise<any> {
            this.setDebitCardStatusChanging();

            const request: SetCardPinRequest = {
                pin: args.pin,
                oldPin: args.oldPin
            };

            return CardService.setDebitCardPin(args.fiservUserInfoId, request)
                .then(response => {
                    this.setFiservDebitCardIsPinSetTrue(args.fiservUserInfoId);
                }).catch(err => {
                    return storeHelper.handleError({ error: err, rethrow: true });
                }).finally(() => {
                    this.setDebitCardStatusNotChanging();
                });
        },
        addFiservDebitCardDependent (args?: {firstName: string, lastName: string}): Promise<any> {
          this.setDebitCardStatusChanging();

          const request: DependentRequest = {
            firstName: args.firstName,
            lastName: args.lastName
          };

          return CardService.addFiservDebitCardDependent(request)
            .then(response => {
              this.setFetchState(FetchState.Uninitialized);
              return this.getFiservDebitCards();
            }).catch(err => {
              return storeHelper.handleError({ error: err, rethrow: true });
            }).finally(() => {
              this.setDebitCardStatusNotChanging();
            });
        },
        deativateFiservDebitCard (fiservUserInfoId: number): Promise<any> {
            this.setDebitCardStatusChanging();
            return CardService.deativateFiservDebitCard(fiservUserInfoId)
                .then(response => {
                    this.setFiservDebitCardStatusCancelled(fiservUserInfoId);
                }).catch(err => {
                    return storeHelper.handleError({
                        error: err, rethrow: true
                    });
                }).finally(() => {
                    this.setDebitCardStatusNotChanging();
                });
        },
        replaceFiservDebitCard (fiservUserInfoId: number): Promise<any> {
          if (this.isPrimaryCardActive === false) {
            return Promise.resolve();
          }
            this.setDebitCardStatusChanging();

            return CardService.replaceFiservDebitCard(fiservUserInfoId)
                .then(response => {
                    this.setFiservDebitCardStatusReplaced(fiservUserInfoId);
                }).catch(err => {
                    return Promise.reject(err);
                }).finally(() => {
                    this.setDebitCardStatusNotChanging();
                });
        },
        confirmReplacementFiservDebitCard (fiservUserInfoId: number): Promise<any> {
            this.setDebitCardStatusChanging();
            return CardService.confirmReplacementFiservDebitCard(fiservUserInfoId)
                .then(response => {
                    this.setFiservDebitCardStatusActive(fiservUserInfoId);
                }).catch(err => {
                    return storeHelper.handleError({ error: err, rethrow: true });
                }).finally(() => {
                    this.setDebitCardStatusNotChanging();
                });
        },
        setFiservDebitCardDetailLocation (location: FiservDebitCardsDetailLocation): Promise<any> {
            this.setfiservDebitCardDetailLocation(location);
            return Promise.resolve();
        },
       dismissFiservDebitCardPendingDependents (fiservAuthorizedSignerPendingId: number): Promise<any> {
            this.setDebitCardStatusChanging();
            return CardService.dismissFiservDebitCardPendingDependent(fiservAuthorizedSignerPendingId)
            .catch(err => storeHelper.handleError({ error: err, rethrow: true }));
        },
    }
});

